export default __webpack_public_path__ + "static/media/slider point.509d0dff.svg";